import m from "./../../../dist/es2015/locales/hi_IN.js";
export const am5locales_hi_IN = m;